const DOTO_PDP_V2_MQ = window.matchMedia('(min-width: 992px)');
const BUYBOX_TYPES = new Set([
  'price',
  'doto-BNPL-highlight',
  'doto-spei-discount',
  'doto-pdp-cashback',
  'buy_buttons',
  'doto-promos-bancarias-PDP',
  'doto-codigoPostal-PDP'
]);
const ADDON_TYPE = 'doto-pdp-smart-addon';

function getDirectMeta(sectionRoot) {
  return sectionRoot.querySelector('[data-element="product-meta"]');
}

function allBlocks(meta) {
  return Array.from(meta.querySelectorAll('[data-meta-block]'));
}

function rememberOrder(meta) {
  allBlocks(meta).forEach((block, index) => {
    if (!block.dataset.dotoV2Order) block.dataset.dotoV2Order = String(index);
  });
}

function restoreMobile(meta) {
  const shell = meta.querySelector(':scope > .doto-pdp-v2__desktop-shell');
  if (!shell) return;
  allBlocks(meta)
    .sort((a,b) => Number(a.dataset.dotoV2Order || 0) - Number(b.dataset.dotoV2Order || 0))
    .forEach(block => meta.insertBefore(block, shell));
  shell.remove();
}

function buildDesktop(meta, sectionRoot) {
  rememberOrder(meta);
  let shell = meta.querySelector(':scope > .doto-pdp-v2__desktop-shell');

  // Upgrade cleanly from the previous two-column runtime shell during editor reloads.
  if (shell && !shell.querySelector(':scope > .doto-pdp-v2__right-rail')) {
    restoreMobile(meta);
    shell = null;
  }

  if (!shell) {
    shell = document.createElement('div');
    shell.className = 'doto-pdp-v2__desktop-shell';

    const info = document.createElement('div');
    info.className = 'doto-pdp-v2__main-info';

    const rightRail = document.createElement('div');
    rightRail.className = 'doto-pdp-v2__right-rail';

    const buybox = document.createElement('aside');
    buybox.className = 'doto-pdp-v2__buybox';

    const addon = document.createElement('div');
    addon.className = 'doto-pdp-v2__addon-slot';

    const sectionId = sectionRoot.dataset.dotoPdpV2Section;
    const sectionEl = sectionId ? document.getElementById(`shopify-section-${sectionId}`) : null;
    const stickySetting = sectionEl?.querySelector('[data-doto-pdp-v2-config]')?.dataset.sticky;
    if (stickySetting !== 'false') rightRail.classList.add('is-sticky');

    rightRail.append(buybox, addon);
    shell.append(info, rightRail);
    meta.append(shell);
  }

  const info = shell.querySelector('.doto-pdp-v2__main-info');
  const rightRail = shell.querySelector('.doto-pdp-v2__right-rail');
  const buybox = rightRail.querySelector('.doto-pdp-v2__buybox');
  const addon = rightRail.querySelector('.doto-pdp-v2__addon-slot');

  allBlocks(meta)
    .sort((a,b) => Number(a.dataset.dotoV2Order || 0) - Number(b.dataset.dotoV2Order || 0))
    .forEach(block => {
      const type = block.dataset.dotoV2BlockType || '';
      const forceBuybox = block.dataset.dotoV2BuyboxForce === 'true';
      if (type === ADDON_TYPE) addon.append(block);
      else if (forceBuybox || BUYBOX_TYPES.has(type)) buybox.append(block);
      else info.append(block);
    });

  addon.hidden = !addon.querySelector('[data-meta-block]');
}

function applySection(sectionRoot) {
  const meta = getDirectMeta(sectionRoot);
  if (!meta) return;
  if (DOTO_PDP_V2_MQ.matches) buildDesktop(meta, sectionRoot);
  else restoreMobile(meta);
}

function applyAll(root = document) {
  root.querySelectorAll?.('[data-doto-pdp-v2-section]').forEach(applySection);
  if (root.matches?.('[data-doto-pdp-v2-section]')) applySection(root);
}

function init() { applyAll(); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
else init();

DOTO_PDP_V2_MQ.addEventListener?.('change', () => applyAll());
document.addEventListener('shopify:section:load', event => applyAll(event.target));
document.addEventListener('shopify:block:select', event => {
  const root = event.target.closest?.('[data-doto-pdp-v2-section]');
  if (root) applySection(root);
});
